import { loadRecommendationsEvents, loadRecommendationsOverviews } from '@common/redux/slices/recommendation.slice';
import { reduxWrapper } from '@common/redux/store';
import { Routes } from '@kursk/components/pages/Routes/Routes';
import { loadEntitiesFromQuery } from '@kursk/utils/loadEntitiesFromQuery';
import React from 'react';

export default function RoutesPage() {

  return <Routes />;
}

export const getServerSideProps = reduxWrapper.getServerSideProps(async ({ store, query }) => {
  await Promise.all([
    loadEntitiesFromQuery('routes', query, store),
    store.dispatch(loadRecommendationsEvents({ locales: query.locales })),
    store.dispatch(loadRecommendationsOverviews({})),
  ]);
  
  return { props: {} };
})